// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row-border-danger {
  /* Outline only: red border around the row without background change */
  border-top: 2px solid #dc3545 !important;
  border-bottom: 2px solid #dc3545 !important;
}

/* Optional: emphasize the first and last cell borders to create full row outline */
.row-border-danger > td:first-child {
  border-left: 2px solid #dc3545 !important;
}

.row-border-danger > td:last-child {
  border-right: 2px solid #dc3545 !important;
}

.print-friendly th:first-child,
.print-friendly td:first-child {
  flex-grow: 1; /* Allow the first column to expand */
  width: auto; /* Let the column adjust as needed */
  max-width: none; /* Remove any maximum width constraint */
  overflow: hidden; /* Avoid content spilling out */
  text-overflow: ellipsis; /* Add ellipsis for overflow text */
  white-space: nowrap; /* Prevent wrapping of text */
}

.drag-cell {
  width: 28px;
  text-align: center;
}

.drag-handle {
  cursor: grab;
  color: #6c757d;
}

.drag-handle:active {
  cursor: grabbing;
}

/* Angular CDK drag feedback */
.cdk-drag-preview {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  opacity: 0.95;
}

.cdk-drag-placeholder {
  opacity: 0;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
